import { render } from "./productDisplay.vue?vue&type=template&id=d7991b9e&scoped=true"
import script from "./productDisplay.vue?vue&type=script&lang=js"
export * from "./productDisplay.vue?vue&type=script&lang=js"

import "./productDisplay.vue?vue&type=style&index=0&id=d7991b9e&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7991b9e"]])

export default __exports__